import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selector } from "../../api";
import { gatewayCRUD } from "../../actions/gateway";
import { TableShared } from "../../shared";
import { char, number } from "../../utils";
import { Button, Dropdown, Space } from "antd";
import {
  MoreOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { DateRangePicker, Input, InputGroup, Message, SelectPicker, useToaster } from "rsuite";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import { ERMSReport } from "./report";
import { ERMSFullData } from "./view";

const { afterToday } = DateRangePicker;

export const ERMSInvoiceContent = () => {
  const [open, setOpen] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [date, setDate] = useState([]);
  const [status, setStatus] = useState("");
  const [controlNumber, setControlNumber] = useState("");
  const [controlNo, setControlNo] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");
  const navigate = useNavigate();

  const dataRef = useRef();
  const tableRef = useRef();

  const toaster = useToaster();

  const user = selector.User();

  const handleControlNumber = () => {
    setControlNumber(controlNo);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      gatewayCRUD
        .loadERMSData(
          postsPerPage,
          nextPage,
          date,
          status,
          "invoice",
          controlNumber,
          value,
          "-id"
        )
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          toaster.push(
            <Message showIcon type={"error"} header={"Error"} closable>
              <p className="h6">
                <p className="fw-bold fs-14">Oooh Sorry...!</p>
                <p className="text-dark fs-12">
                  Something went wrong, Check your network connection.
                </p>
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 }
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, status, date, controlNumber, value, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 70,
    },
    {
      key: "ref",
      title: "Ref No",
      dataIndex: "ref",
      sortable: true,
      width: 170,
    },
    {
      key: "name",
      title: "Payer Name",
      dataIndex: "name",
      sortable: true,
      width: 300,
    },
    {
      key: "control_number",
      title: "Control No",
      dataIndex: "control_number",
      sortable: true,
      width: 130,
    },
    {
      key: "currency",
      title: "Currency",
      dataIndex: "currency",
      sortable: true,
      width: 100,
    },
    {
      key: "amount",
      title: "Amount",
      dataIndex: "amount",
      sortable: true,
      width: 130,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 100,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 70,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <i className="ri-eye-line fs-5" />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                    setDataId(record.id);
                    setOpen(true);
                    break;
                default:
              }
            },
          }}
          trigger={["click"]}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    code: dt.status_code,
    sn: i + 1,
    ref: dt.request ? char.toUpperCase(dt.request.data.client.code) : "N/A",
    name: dt.request ? char.toUpperCase(dt.request.data.client.name) : "N/A",
    control_number: dt.request ? dt.request.data.controlNumber : "N/A",
    currency: dt.request
      ? char.toUpperCase(dt.request.data.currencyCode)
      : "N/A",
    amount: dt.request ? (
      <span className="fw-bold">
        {number.fNumberDoublePoint(dt.request.data.amount)}
      </span>
    ) : (
      "0.00"
    ),
    status: (
      <span
        className={
          dt.status === "success"
            ? "badge badge-soft-success fw-bold"
            : "badge badge-soft-danger fw-bold"
        }
      >
        {dt.status}
      </span>
    ),
  }));

  const handleGeneratePdf = useReactToPrint({
      content: () => dataRef.current,
    });

  return (
    <>
    <ERMSReport data={data} dataRef={dataRef} tableRef={tableRef} title={"invoice"}/>
    <ERMSFullData open={open} setOpen={setOpen} dataId={dataId}/>
      <div className="container-fluid">
        <div className="row mb-2" style={{ marginTop: -30 }}>
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">ERSM Invoice</p>
          </div>
          <hr />
        </div>
        <div className="row mb-1 mt-3" style={{ marginTop: -30 }}>
          <div className="col-12">
            <div className="card shadow border-white p-3">
              <div className="row">
                <div className="col-md-3">
                  <SelectPicker
                    data={[
                      { label: "Success", value: "success" },
                      { label: "Fail", value: "fail" },
                    ]}
                    className="w-100"
                    onChange={(e) => setStatus(e)}
                    onClean={() => setStatus("")}
                  />
                </div>
                <div className="col-md-3">
                  <InputGroup inside className="w-100">
                    <Input
                      onChange={(e) => {
                        setControlNo(e);
                        setControlNumber("");
                      }}
                      value={controlNo}
                    />
                    {controlNumber ? (
                      <InputGroup.Addon
                        role="button"
                        onClick={() => {
                          setControlNumber("");
                          setControlNo("");
                        }}
                      >
                        <i className="bi bi-x-circle" />
                      </InputGroup.Addon>
                    ) : (
                      <InputGroup.Addon
                        role="button"
                        onClick={handleControlNumber}
                      >
                        <i className="bi bi-search" />
                      </InputGroup.Addon>
                    )}
                  </InputGroup>
                </div>
                <div className="col-md-3">
                  <DateRangePicker
                    cleanable
                    placement="bottomEnd"
                    onClean={() => setDate([])}
                    onShortcutClick={(e) => {
                      setDate([
                        moment(e.value[0]).format("YYYY-MM-DD"),
                        moment(e.value[1]).add(1, "days").format("YYYY-MM-DD"),
                      ]);
                    }}
                    onOk={(e) =>
                      setDate([
                        moment(e[0]).format("YYYY-MM-DD"),
                        moment(e[1]).add(1, "days").format("YYYY-MM-DD"),
                      ])
                    }
                    shouldDisableDate={afterToday()}
                    placeholder="Select date range"
                    className="w-100"
                  />
                </div>
                {data.length ? (
                  <>
                    <div className="col-md-3 col-sm-6 text-end">
                      <button
                        className="btn btn-soft-success me-1"
                        disabled={!data}
                      >
                        <DownloadTableExcel
                          filename="erms_invoice"
                          sheet="sheet1"
                          currentTableRef={tableRef.current}
                        >
                          <i className="bi bi-file-earmark-excel me-2" />
                          Excel
                        </DownloadTableExcel>
                      </button>
                      <button
                        onClick={handleGeneratePdf}
                        className="btn btn-soft-danger"
                        disabled={!data}
                      >
                        <i className="bi bi-file-earmark-pdf me-2" />
                        PDF
                      </button>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <TableShared
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
